import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import arrowDown from '../../assets/svg/arrow-down.svg';
import garbage from '../../assets/svg/garbage.svg';

import moment from 'moment';
import Checkbox from '../../components/forms/fields/checkbox';



class CustomCalendarFilterSelect extends React.Component {

    constructor(props) {
        super(props);

        this.selectFieldRef = React.createRef();

        this.state = {
            searchText: '',
            selectedValues: [],
            openedAdditionalItems: []
        }
    }

    setData = (data) => {
        let selectedValues = [];
        if (data?.length) {
            selectedValues = data;
        }
        this.setState({ selectedValues }, () => {
            this.onChangeHandler();
        });
    }



    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);

        if (this.props.registerSetData) {
            this.props.registerSetData(this.setData);
        }


    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.dropdownOpen !== this.state.dropdownOpen && this.state.dropdownOpen === false) {
            this.setState({ searchText: '' })
        }

    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside = (event) => {
        if (this.selectFieldRef?.current && !this.selectFieldRef?.current?.contains(event?.target)) {
            this.closeDropdown();
        }
    }
    openDropdown = () => {
        this.setState({ dropdownOpen: true });
    }
    closeDropdown = () => {
        this.setState({ dropdownOpen: false });
    }
    getItems = (items) => {
        let response = [];
        let search = this.state.searchText?.toLowerCase();
        if (items?.length) {
            items.forEach(item => {
                if (search) {
                    if (this.props.includeAdditionalItems) {
                        // push all main items where label includes search text or that main item contains additional items that includes search text
                        let arr = [];
                        arr.push({
                            ...item,
                            additionalItems: item?.label?.toLowerCase().includes(search) ? item?.additionalItems : item?.additionalItems?.filter(additionalItem => {
                                return additionalItem.label?.toLowerCase().includes(search);
                            })
                        });
                        response = response.concat(arr?.filter(el => el?.additionalItems?.length || el.label?.toLowerCase().includes(search)));

                        let openedAdditionalItems = this.state.openedAdditionalItems ?? [];
                        let updateOpenedAdditionalItems = false;
                        for (let i = 0; i < response.length; i++) {
                            if (!openedAdditionalItems.includes(response[i].value)) {
                                updateOpenedAdditionalItems = true;
                                openedAdditionalItems.push(response[i].value);
                            }
                        }
                        if (updateOpenedAdditionalItems) {
                            this.setState({ openedAdditionalItems });
                        }

                    } else {
                        if (item.label?.toLowerCase().includes(search)) {
                            response.push(item);
                        }
                    }
                } else {
                    response.push(item);
                }
            })
        }

        return response;
    }
    generateValueText = () => {
        const items = this.props.items;
        const selectedValues = this.state.selectedValues;
        let response = '';
        if (this.props.splitValueText) {
            if (selectedValues?.length === 1) {
                response = items.find(item => item.value === selectedValues[0])?.label;
            } else if (selectedValues?.length > 1) {
                response = selectedValues.map(value => {
                    let item = items.find(item => item.value === value);
                    let label = item?.label?.split(' ')?.[0] ?? item?.label;
                    return label;
                }).join(', ');
            }
        } else {
            response = selectedValues.map(value => {
                let item = items.find(item => item.value === value);
                let label = item?.label;
                if (!label) {
                    item = items.find(item => item?.additionalItems?.find(el => el.value === value));
                    if (item?.additionalItems.find(el => el.value === value)?.label) {
                        label = item?.additionalItems.find(el => el.value === value)?.label;
                    }
                }
                return label;
            }).join(', ');
        }


        return response;
    }
    onChangeHandler = (unselectedValue = null) => {
        if (this.props.onChange) {
            this.props.onChange(this.state.selectedValues, unselectedValue);
        }
    }

    render() {
        const items = this.getItems(this.props.items);
        const dropdownOpen = this.state.dropdownOpen;
        // if (items?.length) {
        //     console.log('items', items, dropdownOpen, this.props.placeholder);
        // }
        const valueText = this.generateValueText();
        const multiSelect = this.props.singleSelect ? false : true;

        let isSelectedAll = this.state.selectedValues?.length === this.props.items?.length;
        if (this.props.includeAdditionalItems) {
            let values = [];
            const allItems = this.props.items ?? [];
            allItems.forEach(item => {
                values.push(item.value);
                if (item?.additionalItems?.length) {
                    item?.additionalItems?.forEach(additionalItem => {
                        values.push(additionalItem.value);
                    })
                }
            })
            isSelectedAll = this.state.selectedValues?.length === values.length;
        }
        const itemsWithAtLeastOneSelectedSubItem = this.props.itemsWithAtLeastOneSelectedSubItem ?? [];
        return (
            <FormGroup className='custom-calendar-filter-select-wrap'>
                {this.props.label ? <Label>{this.props.label}</Label> : null}
                <div className='custom-calendar-filter-select-wrap-inner' ref={this.selectFieldRef}>
                    <div className='custom-calendar-filter-select' >
                        <div className='form-control custom-calendar-filter-select-input' style={this.props.inputStyle ?? {}} onClick={() => {
                            if (dropdownOpen) {
                                this.closeDropdown();
                            } else {
                                this.openDropdown();
                            }
                        }}>
                            {valueText ? <span>{valueText}</span> : <span className='placeholder-span'>{this.props.placeholder}</span>}
                        </div>
                    </div>
                    {
                        this.props.actionButton ?
                            <div className='custom-calendar-filter-select-action-button'>
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        this.props.actionButton?.onClick();
                                    }}
                                >
                                    {
                                        this.props.actionButton?.icon ?
                                            <Isvg src={this.props.actionButton.icon} />
                                            :
                                            null
                                    }
                                    {this.props.actionButton?.text}

                                </Button>
                            </div>
                            :
                            null
                    }
                    {
                        dropdownOpen ?
                            <div className='custom-calendar-filter-select-dropdown'>
                                {
                                    multiSelect && this.props.items?.length ?
                                        <div
                                            key={'select-all'}
                                            className='custom-calendar-filter-select-dropdown-item'
                                        >
                                            <Checkbox
                                                onChange={(e) => {
                                                    let value = e.target.checked;
                                                    const allItems = this.props.items ?? [];
                                                    let selectedValues = [];
                                                    if (value) {
                                                        if (this.props.includeAdditionalItems) {
                                                            let values = [];
                                                            allItems.forEach(item => {
                                                                values.push(item.value);
                                                                if (item?.additionalItems?.length) {
                                                                    item?.additionalItems?.forEach(additionalItem => {
                                                                        if (values.indexOf(additionalItem.value) === -1) {
                                                                            values.push(additionalItem.value);
                                                                        }
                                                                    })
                                                                }
                                                            })

                                                            selectedValues = values;
                                                        } else {
                                                            selectedValues = allItems?.map(item => item?.value);
                                                        }

                                                    }
                                                    this.setState({ selectedValues }, () => {
                                                        let unselectedValue = null;
                                                        if (!value) {
                                                            unselectedValue = 'all';
                                                        }
                                                        this.onChangeHandler(unselectedValue);
                                                    });
                                                }}
                                                checked={isSelectedAll}
                                                label={'Select all/none'.translate(this.props.lang)}

                                            />
                                        </div>
                                        :
                                        null
                                }
                                <div className='custom-calendar-filter-select-dropdown-search-item'>
                                    <Input
                                        type='text'
                                        placeholder={'Search'.translate(this.props.lang)}
                                        value={this.state.searchText}
                                        onChange={(e) => {
                                            this.setState({ searchText: e.target.value });
                                        }}
                                    />
                                </div>

                                {
                                    items?.length ?
                                        items?.map((item, index) => {
                                            const additionalItems = item.additionalItems?.length ? item.additionalItems : null;
                                            const label = additionalItems?.length ? `${item.label} (${additionalItems.length})` : item.label;

                                            let selectedAllAdditionalItems = false;
                                            let noSelectedSubItems = false;
                                            if (additionalItems?.length && this.props.selectedAdditionalItems) {
                                                selectedAllAdditionalItems = additionalItems?.every(additionalItem => {
                                                    return this.props.selectedAdditionalItems.includes(additionalItem.value);
                                                });
                                                noSelectedSubItems = additionalItems?.every(additionalItem => {
                                                    return !this.props.selectedAdditionalItems.includes(additionalItem.value);
                                                });
                                            }
                                            const indeterminate = additionalItems?.length && !selectedAllAdditionalItems && !noSelectedSubItems && itemsWithAtLeastOneSelectedSubItem?.indexOf(item._id) ? true : false;

                                            return (
                                                <div
                                                    key={index}
                                                    className='custom-calendar-filter-select-dropdown-item'
                                                >
                                                    <div className='custom-calendar-filter-select-dropdown-item-main'>
                                                        <Checkbox
                                                            onChange={(e) => {
                                                                let unselectedValue;
                                                                let value = e.target.checked;
                                                                let selectedValues = this.state.selectedValues;
                                                                if (value) {
                                                                    if (multiSelect) {
                                                                        selectedValues.push(item.value);
                                                                        if (this.props.includeAdditionalItems) {
                                                                            additionalItems?.forEach(additionalItem => {
                                                                                if (selectedValues.indexOf(additionalItem.value) === -1) {
                                                                                    selectedValues.push(additionalItem.value);
                                                                                }
                                                                            });
                                                                        }
                                                                    } else {
                                                                        selectedValues = [item.value];
                                                                    }
                                                                } else {
                                                                    selectedValues = selectedValues.filter(val => val !== item.value);
                                                                    if (this.props.includeAdditionalItems) {
                                                                        additionalItems?.forEach(additionalItem => {
                                                                            selectedValues = selectedValues.filter(val => val !== additionalItem.value);
                                                                        });
                                                                    }

                                                                    if (additionalItems?.length && !value) {
                                                                        unselectedValue = item.value;
                                                                    }
                                                                }
                                                                this.setState({ selectedValues }, () => {
                                                                    this.onChangeHandler(unselectedValue);
                                                                });
                                                            }}
                                                            checked={this.state.selectedValues.includes(item.value)}
                                                            indeterminate={indeterminate}
                                                            label={label}
                                                            labelAction={() => {
                                                                let openedAdditionalItems = this.state.openedAdditionalItems ?? [];
                                                                if (openedAdditionalItems.includes(item.value)) {
                                                                    openedAdditionalItems = openedAdditionalItems.filter(val => val !== item.value);
                                                                } else {
                                                                    openedAdditionalItems.push(item.value);
                                                                }
                                                                this.setState({ openedAdditionalItems });
                                                            }}
                                                            doOnChangeOnlyOnBoxClick={additionalItems?.length ? true : false}
                                                        />
                                                        {
                                                            this.props.removeHandler ?
                                                                <div
                                                                    className='custom-calendar-filter-select-dropdown-item-additional'
                                                                    onClick={() => {
                                                                        this.props.removeHandler(item.value);
                                                                    }}
                                                                >
                                                                    <Isvg src={garbage} />
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            additionalItems?.length ?
                                                                <div
                                                                    className='custom-calendar-filter-select-dropdown-item-additional'
                                                                    onClick={() => {
                                                                        let openedAdditionalItems = this.state.openedAdditionalItems ?? [];
                                                                        if (openedAdditionalItems.includes(item.value)) {
                                                                            openedAdditionalItems = openedAdditionalItems.filter(val => val !== item.value);
                                                                        } else {
                                                                            openedAdditionalItems.push(item.value);
                                                                        }
                                                                        this.setState({ openedAdditionalItems });
                                                                    }}
                                                                >
                                                                    <Isvg src={arrowDown} />
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                    {
                                                        this.state.openedAdditionalItems?.indexOf(item.value) !== -1 && additionalItems?.map((additionalItem, additionalIndex) => {
                                                            return (
                                                                <div
                                                                    key={additionalIndex}
                                                                    className='custom-calendar-filter-select-dropdown-additional-item'
                                                                >
                                                                    <Checkbox
                                                                        onChange={(e) => {
                                                                            let value = e.target.checked;
                                                                            if (additionalItem.onChange) {
                                                                                additionalItem.onChange(value);
                                                                            }
                                                                        }}
                                                                        disabled={false}
                                                                        checked={additionalItem.checked}
                                                                        label={additionalItem.label}
                                                                    />
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                        :
                                        <div className='no-available-options-message'>{'No available options!'.translate(this.props.lang)}</div>
                                }
                            </div>
                            :
                            null
                    }
                </div>

            </FormGroup >
        )
    }
}

export default CustomCalendarFilterSelect;